var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AccoutCheckService from '@/api/AccoutCheckService';
import VueDialog from "@/interface/IVueDialog";
import { Component, Prop } from 'vue-property-decorator';
import { numMulti, numDiv, numAdd, numSub } from '@/helper/calucate';
import { summaries } from '@/helper/util';
import GLOBAL_VUE from "../../../globalVue";
var Main = (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectUri = '';
        _this.loading = true;
        _this.loadingSearch = false;
        _this.loadingSave = false;
        _this.id = '';
        _this.from = '';
        _this.service = null;
        _this.tenant_status = 0;
        _this.organ_status = 0;
        _this.invoice_status = 0;
        _this.document_status = 0;
        _this.document_preview_status = 0;
        _this.has_un_check_goods = 1;
        _this.provinceList = [];
        _this.noCateGoods = [];
        _this.tax_type_options = [];
        _this.firstTenant = false;
        _this.firstOrgan = false;
        _this.check_goods = false;
        _this.show_warning = true;
        _this.form = {
            order_id: '',
            invoice_type: '',
            company_name: '',
            license_code: '',
            address: '',
            business_address: '',
            area_code: '',
            company_phone: '',
            bank: '',
            banknumber: '',
            contacts: '',
            email: '',
            province_id: '',
            province_name: '',
            tax_qualification: '1',
            export_qualification: '1',
            name: '',
            phone: '',
            taxnumber: '',
        };
        return _this;
    }
    Main.prototype.created = function () {
        var _this = this;
        this.service = AccoutCheckService.getInstance();
        this.initStatus();
        this.initProvince();
        if (GLOBAL_VUE._events['document:ok']) {
            return;
        }
        else {
            var opened_1 = false;
            GLOBAL_VUE.$on('document:ok', function () {
                if (opened_1)
                    return;
                opened_1 = true;
                setTimeout(function () { return opened_1; }, 3000);
                _this.$message.success('开票成功');
                _this.$emit('openDocumentList');
                _this.close();
            });
        }
    };
    Main.prototype.taxNormalizer = function (node) {
        return {
            id: node.type_code,
            label: node.type_name,
            children: node.children,
        };
    };
    Main.prototype.getThirdInvoice = function () {
        var _this = this;
        if (!this.id) {
            this.$message.warning('请先保存对账单后再执行开票');
            return;
        }
        this.service.getThirdInvoice({
            order_id: this.id
        }).then(function (res) {
            if (res.data.code === 0) {
                _this.$message.success(res.data.msg || '获取百望云发票成功');
                _this.$emit('getInvoiceStatus');
                _this.close();
            }
            else {
                _this.$message.error(res.data.msg || '获取百望云发票失败');
            }
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Main.prototype.getSummaries = function (param) {
        var _this = this;
        var data = param.data;
        var sums = [];
        var showSum = ['supplier_goods_name', 'order_detail_amount', 'order_detail_money', 'order_detail_tax_money', 'order_detail_total_money'];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        sums[1] = data.length + "\u79CD\u8D27\u54C1";
        sums[11] = data.reduce(function (pre, cur) { return numAdd(pre, _this.getRowValue('order_detail_money', cur)); }, 0);
        sums[12] = data.reduce(function (pre, cur) { return numAdd(pre, _this.getRowValue('order_detail_tax_money', cur)); }, 0);
        sums[13] = data.reduce(function (pre, cur) { return numAdd(pre, _this.getRowValue('order_detail_total_money', cur)); }, 0);
        return sums;
    };
    Main.prototype.getRowValue = function (field, row) {
        var order_detail_uprice = row.order_detail_uprice, order_detail_amount = row.order_detail_amount, tax_rate = row.tax_rate;
        var precent_tax_rate = numDiv(tax_rate, 100);
        var amount_including_tax = numMulti(order_detail_uprice, order_detail_amount).toFixed(2);
        var tax_amount = numDiv(numMulti(amount_including_tax, precent_tax_rate), numAdd(1, precent_tax_rate)).toFixed(2);
        var amount_before_tax = numSub(amount_including_tax, tax_amount).toFixed(2);
        if (field == 'order_detail_money') {
            return amount_before_tax;
        }
        if (field == 'order_detail_tax_money') {
            return tax_amount;
        }
        if (field == 'order_detail_total_money') {
            return amount_including_tax;
        }
        return '-';
    };
    Main.prototype.initProvince = function () {
        var _this = this;
        this.service.getProvince()
            .then(function (res) {
            var _a = res.data, success = _a.success, data = _a.data;
            if (success) {
                _this.provinceList = data;
            }
            console.log('res>>>', res);
        });
    };
    Main.prototype.initGoodsCategory = function () {
        var _this = this;
        this.loadingSearch = true;
        this.service.getGoodsCategory({ keyword: '' })
            .then(function (res) {
            var _a = res.data, data = _a.data, success = _a.success;
            if (success) {
                _this.tax_type_options = (data || []);
            }
        }).finally(function () {
            _this.loadingSearch = false;
        });
    };
    Main.prototype.initStatus = function () {
        var _this = this;
        this.loading = true;
        var width = 800;
        var height = 690;
        this.service.isOpenBaiWang({
            'order_id': this.id,
            'invoice_type': this.form.invoice_type,
        })
            .then(function (res) {
            var _a = res.data || {}, success = _a.success, data = _a.data, msg = _a.msg;
            if (success) {
                console.log('isOpenBaiWang>>>', _this.from, _this.organ_status);
                _this.tenant_status = data.tenant_status;
                _this.organ_status = data.organ_status;
                _this.invoice_status = data.invoice_status;
                _this.document_status = data.document_status;
                if (_this.from != 'menu') {
                    _this.getGoods();
                    _this.initGoodsCategory();
                }
                if (_this.isSuccess) {
                    width = 440;
                    height = 300;
                    _this.redirectUri = data.redirect_uri;
                    _this.redirectBwy();
                    _this.show_warning = false;
                }
                if (!_this.showGoodsPreview()) {
                    _this.$styleDialog({
                        width: width + "px",
                        height: height + "px",
                        top: "calc(50% - " + height / 2 + "px)",
                        left: "calc(50% - " + width / 2 + "px)",
                    });
                }
            }
            else {
                _this.close();
                _this.$message.error(msg || '数据加载失败');
            }
        }).catch(function (e) {
            _this.close();
            _this.$message.error(e.message || e.msg || '数据加载失败');
        }).finally(function () {
            _this.loading = false;
        });
    };
    Main.prototype.redirectBwy = function () {
        var _this = this;
        setTimeout(function () {
            _this.redirectUri && window.open(_this.redirectUri);
        }, 1000);
    };
    Main.prototype.updateStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.service.isOpenBaiWang({
                            'order_id': this.id,
                            'invoice_type': this.form.invoice_type,
                        }).then(function (res) {
                            var _a = res.data || {}, success = _a.success, data = _a.data;
                            if (success) {
                                _this.tenant_status = data.tenant_status;
                                _this.organ_status = data.organ_status;
                                _this.invoice_status = data.invoice_status;
                                _this.document_status = data.document_status;
                                console.log('isOpenBaiWang>>>', data);
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Main.prototype.close = function () {
        this.$closeDialog();
        this.$emit('close');
    };
    Main.prototype.getGoods = function () {
        var _this = this;
        this.service.getInvoiceGoods({
            order_id: this.id
        }).then(function (res) {
            var _a = res.data || {}, code = _a.code, msg = _a.msg, data = _a.data;
            if (code === 0) {
                _this.has_un_check_goods = data.has_un_check_goods;
                if (!_this.has_un_check_goods) {
                    _this.show_warning = false;
                }
                var arr = data.goods_list || [];
                _this.noCateGoods = arr.sort(function (a, b) {
                    return a.has_tax_type - b.has_tax_type;
                });
            }
            else if (code === 86) {
                _this.show_warning = false;
                _this.$message.success(msg);
                _this.$emit('refresh');
            }
            else {
                _this.$message.error(msg);
            }
        }).catch(function (err) {
        });
    };
    Main.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var func, postData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('form>>>', this.form);
                        if (this.loadingSave) {
                            return [2];
                        }
                        if (!(this.tenant_status == 1 && this.organ_status == 1 && this.document_status == 0)) return [3, 2];
                        if (this.form.invoice_type === '') {
                            this.$message.error('请选择发票类型');
                            return [2, false];
                        }
                        return [4, this.updateStatus()];
                    case 1:
                        _a.sent();
                        if (this.invoice_status == 0) {
                            this.show_warning = true;
                            this.document_status = 1;
                            return [2];
                        }
                        else {
                            func = 'createOrderDocument';
                            postData = {
                                'order_id': this.id,
                                'invoice_type': this.form.invoice_type,
                                'data': JSON.stringify(this.noCateGoods),
                            };
                            this.submitData(func, postData);
                            return [2];
                        }
                        _a.label = 2;
                    case 2:
                        this.$refs.form.validate(function (valid) {
                            if (!valid) {
                                return;
                            }
                            _this.loadingSave = true;
                            _this.form.province_name = _this.provinceName;
                            _this.form.order_id = _this.id;
                            _this.form.company_phone = _this.form.area_code ? _this.form.area_code + "-" + _this.form.company_phone : _this.form.company_phone;
                            var func = '';
                            if (_this.tenant_status == 0) {
                                func = 'generateInvoiceAccount';
                            }
                            else if (_this.organ_status == 0) {
                                func = 'bindOrg';
                            }
                            else if (_this.invoice_status == 0) {
                                func = 'updateInvoiceInfo';
                                _this.form.taxnumber = _this.form.license_code;
                                _this.form.name = _this.form.company_name;
                                _this.form.phone = _this.form.company_phone;
                            }
                            _this.submitData(func, _this.form);
                        });
                        this.$emit('submit', this.form);
                        return [2];
                }
            });
        });
    };
    Main.prototype.submitData = function (func, postData) {
        var _this = this;
        this.service[func](postData)
            .then(function (res) {
            console.log('res>>>', res);
            _this.loadingSave = false;
            if (_this.tenant_status == 0) {
                _this.firstTenant = true;
                _this.tenant_status = 1;
                _this.organ_status = 1;
                if (_this.document_status == 1 && _this.invoice_status == 1) {
                    _this.redirectUri = res.data.data.redirect_uri;
                }
            }
            else if (_this.organ_status == 0) {
                _this.firstOrgan = true;
                _this.organ_status = 1;
                if (_this.document_status == 1 && _this.invoice_status == 1) {
                    _this.redirectUri = res.data.data.redirect_uri;
                }
            }
            else if (_this.document_status == 0 || _this.document_preview_status == 1) {
                _this.document_status = 1;
                _this.show_warning = false;
                if (_this.document_status == 1 && _this.invoice_status == 1) {
                    _this.redirectUri = res.data.data.redirect_uri;
                }
            }
            else if (_this.invoice_status == 0) {
                _this.invoice_status = 1;
                _this.document_preview_status = 1;
                _this.submitData(func, postData);
            }
            if (res.data.code === 81) {
                var resData = res.data.data;
                _this.document_status = 0;
                var ids = resData.goods_ids;
                var goodList = JSON.parse(JSON.stringify(_this.noCateGoods));
                for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
                    var val = ids_1[_i];
                    for (var _a = 0, goodList_1 = goodList; _a < goodList_1.length; _a++) {
                        var obj = goodList_1[_a];
                        if (val == obj.goods_id) {
                            obj.showRed = true;
                            break;
                        }
                    }
                }
                _this.noCateGoods = goodList;
                _this.$confirm("\u53D1\u7968\u603B\u7A0E\u989D\u548C\u8D26\u5355\u5E94\u5F00\u7968\u603B\u7A0E\u989D\u5B58\u5728\u5DEE\u5F02\uFF0C\u5BA2\u6237\u8981\u6C42\u5DEE\u5F02\u4E0D\u8D85\u8FC7" + resData.tax_money_diff + " \u5143\uFF0C\u662F\u5426\u7EE7\u7EED\u63D0\u4EA4\uFF1F", '提示', {
                    confirmButtonText: '确认提交',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    var func = 'createOrderDocument';
                    var postData = {
                        'order_id': _this.id,
                        'invoice_type': _this.form.invoice_type,
                        'data': JSON.stringify(_this.noCateGoods),
                        'confirm_diff_tax_money': 1
                    };
                    _this.invoice_status = 1;
                    _this.document_preview_status = 1;
                    _this.submitData(func, postData);
                }).catch(function () {
                });
                return;
            }
            if (_this.isSuccess) {
                var width = 400;
                var height = 300;
                _this.$styleDialog({
                    width: width + "px",
                    height: height + "px",
                    top: "calc(50% - " + height / 2 + "px)",
                    left: "calc(50% - " + width / 2 + "px)",
                });
                _this.redirectBwy();
            }
            _this.showGoodsPreview();
        }).catch(function (err) {
            _this.loadingSave = false;
            _this.$message.error(err.msg || err.message);
        });
    };
    Main.prototype.showGoodsPreview = function () {
        if (this.tenant_status == 1 && this.organ_status == 1 && this.document_status == 0) {
            var width = 1200;
            var height = 690;
            this.$styleDialog({
                width: width + "px",
                height: height + "px",
                top: "calc(50% - " + height / 2 + "px)",
                left: 'calc(50% - 600px)',
            }, '发票开具-开票数据预览');
            return true;
        }
        return false;
    };
    Main.prototype.querySearch = function (queryString, cb) {
        var _this = this;
        if (!/^\s*$/.test(queryString) && queryString.length >= 3) {
            this.service.getCompanyByKeyword({
                keyword: queryString
            }).then(function (res) {
                console.log('querySearch res>>>', res);
                if (res.data.code === 0) {
                    var results = res.data.data.map(function (item) {
                        return {
                            value: item.company_name,
                            code: item.company_license_code
                        };
                    });
                    cb(results);
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            cb([]);
        }
    };
    Main.prototype.handleSelect = function (item) {
        var _this = this;
        this.form.company_name = item.value;
        this.form.license_code = item.code;
        this.service.getCompanyInfo({ company_name: item.value, license_code: item.code })
            .then(function (res) {
            console.log('res>>>', res);
            if (_this.tenant_status == 0) {
                if (res.data.data.length == 0) {
                    _this.form.bank = '';
                    _this.form.banknumber = '';
                    _this.form.business_address = '';
                    _this.form.area_code = '';
                    _this.form.company_phone = '';
                    _this.form.province_id = '';
                    _this.form.province_name = '';
                }
                else {
                    var data = res.data.data;
                    _this.form.bank = data.bank;
                    _this.form.banknumber = data.bankAccount;
                    _this.form.business_address = data.location;
                    _this.splitPhone(data.fixedPhone);
                    _this.form.province_id = data.province_id;
                    _this.form.province_name = data.province;
                }
            }
            else {
                if (res.data.data.length == 0) {
                    _this.form.bank = '';
                    _this.form.banknumber = '';
                    _this.form.address = '';
                    _this.form.business_address = '';
                    _this.form.area_code = '';
                    _this.form.company_phone = '';
                    _this.form.contacts = '';
                }
                else {
                    var data = res.data.data;
                    _this.form.bank = data.bank;
                    _this.form.banknumber = data.bankAccount;
                    _this.form.address = data.location;
                    _this.form.business_address = data.location;
                    _this.splitPhone(data.fixedPhone);
                    _this.form.contacts = '';
                }
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    Main.prototype.splitPhone = function (phone_str) {
        var phones;
        if (phone_str.includes('-')) {
            phones = phone_str.split("-");
        }
        else {
            phones = phone_str.split("－");
        }
        if (phones.length == 1) {
            this.form.area_code = '';
            this.form.company_phone = phone_str;
        }
        else {
            this.form.area_code = phones[0];
            this.form.company_phone = phones[1];
        }
    };
    Main.prototype.handleRedirect = function () {
        var _this = this;
        this.service.isOpenBaiWang({ order_id: this.id })
            .then(function (res) {
            var _a = res.data || {}, success = _a.success, data = _a.data;
            if (success) {
                _this.redirectUri = data.redirect_uri;
                _this.redirectBwy();
            }
        });
    };
    Main.prototype.taxTypeChange = function (row, node) {
        row.tax_type_id = node.type_id;
        row.tax_type_code = node.type_code;
        row.tax_rate = node.tax_rate;
        row.tax_rate_real = numDiv(node.tax_rate, 100);
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Main.prototype, "showFooter", void 0);
    Main = __decorate([
        Component({
            name: 'GenerateInvoice',
            computed: {
                rules: function () {
                    var isNormalInvoice = ['EINVOICE_VAT', 'GENERAL_VAT', 'ELE_GENERAL_VAT'].includes(this.form.invoice_type);
                    var result = {
                        company_name: [
                            { required: true, message: '请输入公司名称', trigger: 'blur' }
                        ],
                        license_code: [
                            { required: true, message: '请输入信用代码', trigger: 'blur' }
                        ],
                        bank: [
                            { message: '请输入开户行', required: !isNormalInvoice || !this.tenant_status, trigger: 'blur' }
                        ],
                        banknumber: [
                            { message: '请输入银行账号', required: !isNormalInvoice || !this.tenant_status, trigger: 'blur' }
                        ],
                        province_id: [
                            { message: '请选择纳税省份', required: !this.tenant_status, trigger: 'blur' }
                        ],
                        tax_qualification: [
                            { message: '请选择纳税资质', required: !this.tenant_status, trigger: 'blur' }
                        ],
                        export_qualification: [
                            { message: '请选择出口资质', required: !this.tenant_status, trigger: 'blur' }
                        ],
                        business_address: [
                            { message: '请输入公司地址', required: !this.tenant_status, trigger: 'blur' }
                        ],
                        company_phone: [
                            { message: '请输入公司电话', required: !this.tenant_status, trigger: 'blur' }
                        ],
                        email: [
                            { message: '请输入邮箱', required: !this.tenant_status, trigger: 'blur' }
                        ],
                    };
                    if (this.organ_status == 1) {
                        result.company_name.required = true;
                        result.company_name.message = '请输入公司抬头';
                        result.license_code.required = true;
                        result.license_code.message = '请输入公司税号';
                    }
                    return result;
                },
                provinceName: function () {
                    var id = this.form.province_id;
                    var province = this.provinceList.find(function (item) { return item.id == id; });
                    return province ? province.name : '';
                },
                isSuccess: function () {
                    return this.organ_status == 1 && this.tenant_status == 1 && this.document_status == 1 && this.invoice_status == 1;
                }
            },
        })
    ], Main);
    return Main;
}(VueDialog));
export default Main;
